<template>

	<div class="nav">

    	<a class="nav__link" href="#" @click.stop.prevent="toggleNav"><slot name="thumb"></slot></a>

		<transition name="fade-down">

			<div class="nav__container" v-if="showNav" v-click-outside="hideNav" @click="hideNav">

    			<slot name="content"></slot>

    		</div>

		</transition>

    </div>

</template>

<script>
    export default {
        name: "dropdown",
		data(){
          return {
              showNav: false,
		  }
		},
		methods:{
            toggleNav(){
                this.showNav = !this.showNav;
            },
            hideNav(){
                this.showNav = false;
            },
		}
    }
</script>

<style scoped>

</style>
